export default "__VITE_ASSET__8hNKfIiI__"